// extracted by mini-css-extract-plugin
export default {"radioConfigModalContent":"MPW_radioConfigModalContent__D3G0R","dynamicConfigContent":"MPW_dynamicConfigContent__Bv03R"};